module.exports = __webpack_public_path__ + "static/img/7.eb11c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/7.png
// module id = QYJe
// module chunks = 1